<template>
  <BaseIcon
    :showIcon="showIcon"
    :imgSrc="imgSrc"
    imgAlt="Communication Icon"
    :iconText="iconText"
    tooltipContentClass="communication-status-tooltip"
    dataCy="communicationStatus"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import BaseIcon from './BaseIcon.vue'

// connected devices are devices that communicate via a smart bridge
const CONNECTED = 'connected'
// standalone devices are devices that communicate directly with TSI Link
const STANDALONE = 'standalone'

const IMG_SRC: Record<string, string> = {
  [CONNECTED]: '/img/icons/connected_device_communication_icon.svg',
  [STANDALONE]: '/img/icons/device_communication_icon.svg'
}
const ICON_TEXT: Record<string, string> = {
  [CONNECTED]: 'device.icons.communicationStatus.connectedDevice',
  [STANDALONE]: 'device.icons.communicationStatus.device'
}

export default defineComponent({
  name: 'CommunicationStatus',
  components: {
    BaseIcon
  },
  props: {
    deviceId: { type: String, default: '' }
  },
  computed: {
    deviceType() {
      return this.isDeviceConnectedToSmartBridge ? CONNECTED : STANDALONE
    },
    isDeviceConnectedToSmartBridge(): boolean {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.IS_DEVICE_CONNECTED_TO_SMART_BRIDGE}`
      ](this.deviceId)
    },
    isSmartBridgeConnected(): boolean {
      const smartBridgeDeviceId = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_CONNECTED_SMART_BRIDGE_ID_BY_DEVICE_ID}`
      ](this.deviceId)
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`
      ](smartBridgeDeviceId)
    },
    isDeviceConnected(): boolean {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    isDeviceSendingTelemetry(): boolean {
      return !!this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_TELEM_TX_TYPE_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    imgSrc() {
      return IMG_SRC[this.deviceType]
    },
    iconText() {
      if (this.isDeviceSendingTelemetry) {
        return this.$t(ICON_TEXT[this.deviceType])
      }

      return ''
    },
    showIcon() {
      return (
        this.isDeviceSendingTelemetry &&
        this.isDeviceConnected &&
        (this.deviceType === STANDALONE || this.isSmartBridgeConnected)
      )
    }
  }
})
</script>
